import { postRequest, readRequest } from "../../web";

const MANAGE_SETTINGS_URL = "api/system/user-setting";

export function updateUserSettings(key: string, value: any) {
    const payload = {
        Key: key,
        Value: value,
    };

    return postRequest<any, any>(`${MANAGE_SETTINGS_URL}`, payload);
}

export function readUserSetting() {
    return readRequest<any>(`${MANAGE_SETTINGS_URL}`);
}
